const getInitialPosition = (element, modalRef) => {
  var _a, _b;
  if (!element)
    return void 0;
  const { innerWidth, innerHeight } = window;
  const { width, x: initialXPosition, y: initialYPosition } = element.getBoundingClientRect();
  const MARGIN = 8;
  const defaultX = initialXPosition ?? 0;
  const defaultY = initialYPosition ?? 0;
  const nodeHeight = ((_a = modalRef == null ? void 0 : modalRef.current) == null ? void 0 : _a.offsetHeight) ?? 0;
  const nodeWidth = ((_b = modalRef == null ? void 0 : modalRef.current) == null ? void 0 : _b.offsetWidth) ?? 0;
  const dialogMaxRightPosition = width + initialXPosition + nodeWidth + MARGIN;
  const dialogRightPosition = defaultX + width + MARGIN;
  const dialogLeftPosition = defaultX - nodeWidth - MARGIN;
  const initialY = nodeHeight + defaultY > innerHeight ? innerHeight - nodeHeight - MARGIN : defaultY;
  const initialX = (
    // eslint-disable-next-line no-nested-ternary
    dialogMaxRightPosition > innerWidth ? dialogLeftPosition > 0 ? dialogLeftPosition : 0 : dialogRightPosition
  );
  return {
    x: initialX,
    y: initialY
  };
};
export {
  getInitialPosition
};
